import { Card, CardContent, Typography, Box, Rating } from '@mui/material';
import type { SyncScore } from '../utils/riskAssessment';

interface SyncScoreCardProps {
    sync: SyncScore;
}

export const SyncScoreCard = ({ sync }: SyncScoreCardProps) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" gutterBottom>
                    Sync Potential
                </Typography>
                <Box display="flex" alignItems="center" gap={1} mb={1}>
                    <Rating value={sync.tier} max={5} readOnly size="large" />
                    <Typography variant="subtitle1">{sync.label}</Typography>
                </Box>
                <Typography variant="body2" color="textSecondary">
                    {sync.reasoning}
                </Typography>
            </CardContent>
        </Card>
    );
};
